<script setup>
  import { useRouter } from "vue-router";

  import { showComingSoonAlert } from "@/utils";

  const router = useRouter();

  const openPopup = (type) => {
    const url = router.resolve({
      name: type === "privacy" ? "PrivacyPopup" : "TermsPopup",
    }).href;

    const width = 860;
    const height = Math.round(screen.availHeight * 0.9);
    const left = Math.round((screen.availWidth - width) / 2);
    const top = Math.round((screen.availHeight - height) / 2);

    const popup = window.open(
      url,
      "ExamWatchMonitoring",
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
    );

    if (popup) {
      popup.focus();
    }
  };

  const openExternalLink = (url) => {
    window.open(url, "_blank");
  };
</script>

<template>
  <footer>
    <div class="fb-container">
      <div class="fb-top">
        <img
          src="@/assets/images/logo_footer.png"
          alt="서울특별시교육청"
          class="fb-top__logo"
        />
        <div class="fb-links">
          <a
            href="#none"
            class="fb-links__item fb-links__item--privacy"
            title="새 창"
            @click.prevent="
              openExternalLink(
                'https://www.sen.go.kr/user/bbs/BD_selectBbsList.do?q_bbsSn=1009',
              )
            "
            >개인정보처리방침</a
          >
          <a
            href="#none"
            class="fb-links__item"
            title="새 창"
            @click.prevent="openPopup('terms')"
            >이용약관</a
          >
          <a
            href="#none"
            class="fb-links__item"
            @click.prevent="showComingSoonAlert()"
            >사이트맵</a
          >
        </div>
      </div>
      <p class="fb-copy">
        &copy;COPYRIGHT 2026. SEOUL METROPOLITAN OFFICE OF EDUCATION. ALL RIGHTS
        RESERVED. Powered by Whale UBT.
      </p>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
  footer {
    flex-shrink: 0;
    width: 100%;
    background: #fff;
    border-top: 1px solid #eef0f6;
    padding: 36px 0 30px;
    min-width: var(--smoe-content-w);
    z-index: 10;
  }

  .fb-container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 24px;
  }

  .fb-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding-bottom: 22px;
    margin-bottom: 26px;
    border-bottom: 1px solid #e8e8e8;

    &__logo {
      width: 156px;
      height: auto;
    }
  }

  .fb-links {
    display: flex;
    align-items: center;
    gap: 40px;

    &__item {
      font-size: 15px;
      color: #1c1c1c;

      &:hover {
        text-decoration: underline;
        text-underline-offset: 4px;
      }

      &--privacy {
        font-weight: 700;
        color: #3b82f6;
      }
    }
  }

  .fb-copy {
    font-size: 12px;
    color: #8a8a8a;
    text-align: center;
    line-height: 1.55;
  }
</style>
